import { createStyles, makeStyles, Theme,createTheme } from '@material-ui/core/styles';

const defaultTheme = createTheme({});
const { pxToRem } = defaultTheme.typography;


export const TableBaseStyle = makeStyles(
  createStyles({
    //テーブルヘッダセル
    headerCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
      padding: '1px',
    },
    bodyCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      padding: '0.5px',
      height: '10px',
    },
    bodyCellCenter: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'center',
      padding: '0px',
      height: '10px',
    },
    bodyRow: {
      '&.Mui-selected, &.Mui-selected:hover': {
        //背景色
        backgroundColor: 'yellow',
        '& > .MuiTableCell-root': {
          //文字色
          color: 'brack',
        },
      },
    },
    //テキスト
      textField: {
        flexGrow: 1,
        height: '100%',
        width: '100%',
        border: 'none',
        backgroundColor: 'transparent',
        textAlign: "center",
    },
  })
);

export const ChartBaseStyle = makeStyles(
  createStyles({
    tooltip: {
      background: '#FFFFEE',
      fontSize: '14px',
      padding: '10px 10px 0px 20px',
    },
  })
);

export const EMCTrendStyle = makeStyles(
  createStyles({
     tableContainer: {
      maxHeight: 'calc(100vh - 276px)',
    },
     chartContainer: {
      minHeight: 'calc(100vh - 276px)',
      maxHeight: 'calc(100vh - 276px)',
    },
    //画面ヘッダ部ペーパ＾
     paperRoot: {
      maxWidth: '1100px',
      minWidth: '1100px',
      padding: '3px',
    },
    buttonRoot: {
      minWidth: '130px',
    },
    //画面ヘッダ部ラジオボタン
    muiTypography: {
      fontSize: pxToRem(14),
      lineHeight: 1.66,
    },
     //画面で使用しているチェックボックス
    checkBox: {
      padding: '0px',
    },
    spacingXs1: {
      minWidth: '1440px',
    },
  })
);

export const FooterBaseStyle = makeStyles(
  createStyles({
    buttonStyle: {
      maxWidth: '180px',
      maxHeight: '35px',
      minWidth: '180px',
      minHeight: '35px',
    },
  })
);
